import { all, call, put, takeEvery } from 'redux-saga/effects'

import { referenceApi } from '../../api/referenceApi'
import {
    REFERENCE_LOAD,
    REFERENCE_LOAD_AUDIENCE,
    REFERENCE_LOAD_EDITOR_AUDIENCE,
    REFERENCE_LOAD_EDITOR_DATA,
    REFERENCE_LOAD_PAGE_DATA,
} from '../actions/references'
import { referencesActions } from '../slices/references'

const TABLE_SETTERS = {
    groups: referencesActions.setGroups,
    teachers: referencesActions.setTeachers,
    subjects: referencesActions.setSubjects,
    classes_types: referencesActions.setClassTypes,
    buildings: referencesActions.setBuildings,
    bell_schedule: referencesActions.setBells,
}

const TABLE_ERRORS = {
    groups: 'Не удалось загрузить список групп',
    teachers: 'Не удалось загрузить список преподавателей',
    subjects: 'Ошибка загрузки предметов',
    classes_types: 'Ошибка загрузки типов занятий',
    buildings: 'Ошибка загрузки корпусов',
    bell_schedule: 'Ошибка загрузки расписания звонков',
}

const TABLE_LOADING_KEYS = {
    groups: 'groups',
    teachers: 'teachers',
    subjects: 'subjects',
    classes_types: 'classTypes',
    buildings: 'buildings',
    bell_schedule: 'bells',
}

const normalizeList = (data) => (Array.isArray(data) ? data : [data])

function* referenceLoadSaga(action) {
    const table = action.payload

    try {
        const loadingKey = TABLE_LOADING_KEYS[table] || table
        yield put(referencesActions.setTableLoading({ table: loadingKey, value: true }))
        yield put(referencesActions.setError(null))

        const data = yield call(referenceApi.getTable, table)
        const setter = TABLE_SETTERS[table]

        if (setter) {
            yield put(setter(normalizeList(data)))
        }
    } catch (error) {
        console.error(`REFERENCE ERROR (${table}):`, error)
        yield put(referencesActions.setError(
            error instanceof Error ? error.message : TABLE_ERRORS[table] || 'Ошибка загрузки справочника'
        ))

        const setter = TABLE_SETTERS[table]
        if (setter) {
            yield put(setter([]))
        }
    } finally {
        const loadingKey = TABLE_LOADING_KEYS[table] || table
        yield put(referencesActions.setTableLoading({ table: loadingKey, value: false }))
    }
}

function* referenceLoadPageDataSaga() {
    yield all([
        call(referenceLoadSaga, { payload: 'groups' }),
        call(referenceLoadSaga, { payload: 'teachers' }),
        call(referenceLoadSaga, { payload: 'subjects' }),
        call(referenceLoadSaga, { payload: 'classes_types' }),
        call(referenceLoadSaga, { payload: 'buildings' }),
    ])
}

function* referenceLoadEditorDataSaga() {
    yield all([
        call(referenceLoadSaga, { payload: 'groups' }),
        call(referenceLoadSaga, { payload: 'teachers' }),
        call(referenceLoadSaga, { payload: 'bell_schedule' }),
        call(referenceLoadSaga, { payload: 'subjects' }),
        call(referenceLoadSaga, { payload: 'classes_types' }),
        call(referenceLoadSaga, { payload: 'buildings' }),
    ])
}

function* referenceLoadAudienceSaga(action) {
    const buildingId = action.payload

    if (!buildingId) {
        yield put(referencesActions.resetRooms())
        return
    }

    try {
        yield put(referencesActions.setTableLoading({ table: 'audience', value: true }))

        const data = yield call(referenceApi.getAudience, buildingId)
        yield put(referencesActions.setRooms(normalizeList(data)))
    } catch (error) {
        console.error('AUDIENCE ERROR:', error)
        yield put(referencesActions.setRooms([]))
    } finally {
        yield put(referencesActions.setTableLoading({ table: 'audience', value: false }))
    }
}

function* referenceLoadEditorAudienceSaga(action) {
    const buildingId = action.payload

    if (!buildingId) {
        yield put(referencesActions.resetEditorRooms())
        return
    }

    try {
        yield put(referencesActions.setTableLoading({ table: 'editorAudience', value: true }))

        const data = yield call(referenceApi.getAudience, buildingId)
        yield put(referencesActions.setEditorRooms(normalizeList(data)))
    } catch (error) {
        console.error('EDITOR AUDIENCE ERROR:', error)
        yield put(referencesActions.resetEditorRooms())
    } finally {
        yield put(referencesActions.setTableLoading({ table: 'editorAudience', value: false }))
    }
}

function* referenceLoadWatch() {
    yield takeEvery(REFERENCE_LOAD, referenceLoadSaga)
}

function* referenceLoadPageDataWatch() {
    yield takeEvery(REFERENCE_LOAD_PAGE_DATA, referenceLoadPageDataSaga)
}

function* referenceLoadEditorDataWatch() {
    yield takeEvery(REFERENCE_LOAD_EDITOR_DATA, referenceLoadEditorDataSaga)
}

function* referenceLoadAudienceWatch() {
    yield takeEvery(REFERENCE_LOAD_AUDIENCE, referenceLoadAudienceSaga)
}

function* referenceLoadEditorAudienceWatch() {
    yield takeEvery(REFERENCE_LOAD_EDITOR_AUDIENCE, referenceLoadEditorAudienceSaga)
}

export default function* referencesRootSaga() {
    yield all([
        referenceLoadWatch(),
        referenceLoadPageDataWatch(),
        referenceLoadEditorDataWatch(),
        referenceLoadAudienceWatch(),
        referenceLoadEditorAudienceWatch(),
    ])
}
